/**
 * @generated SignedSource<<3750f4ed61e3265ce82e7d828d60463d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
import { FragmentRefs } from "relay-runtime";
export type WidgetRoutineOverviewDataComponent_widgetRoutineOverview$data = {
  readonly id: string;
  readonly routines: ReadonlyArray<{
    readonly id: string;
    readonly inProgressOccasion: {
      readonly expireAt: string;
      readonly startAt: string;
      readonly status: RoutineOccasionStatus;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverviewListItem_routineOccasion">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverviewListItem_routine">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "WidgetRoutineOverviewDataComponent_widgetRoutineOverview";
};
export type WidgetRoutineOverviewDataComponent_widgetRoutineOverview$key = {
  readonly " $data"?: WidgetRoutineOverviewDataComponent_widgetRoutineOverview$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverviewDataComponent_widgetRoutineOverview">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetRoutineOverviewDataComponent_widgetRoutineOverview",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routines",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetRoutineOverviewListItem_routine"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineOccasion",
          "kind": "LinkedField",
          "name": "inProgressOccasion",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expireAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "calculateNoTasks",
                  "value": true
                }
              ],
              "kind": "ScalarField",
              "name": "status",
              "storageKey": "status(calculateNoTasks:true)"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetRoutineOverviewListItem_routineOccasion"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetRoutineOverview",
  "abstractKey": null
};
})();

(node as any).hash = "35cee64c2e000b30b956706d66789af2";

export default node;
